import { fromJS, Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import axios from 'axios';

import * as registerLib from 'libs/registerLib';

// action types
const INITIAL_STORE = 'register/INITIAL_STORE';
const POST_REGISTER = 'register/POST_REGISTER';
const SET_INITIAL = 'register/SET_INITIAL';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const postRegister = createAction(POST_REGISTER, registerLib.postRegisterAPI);
export const setInitial = createAction(SET_INITIAL);

const initialState = Map({
  register: Map({
    isRegister: false,
    userData: Map({})
  })
});

export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    ...pender({
      type: POST_REGISTER,
      onSuccess: (state, action) => {
        let { list } = action.payload.data;

        list = {
          isRegister: true,
          ...list
        };

        return state.set('register', fromJS(list));
      },
      //서비스 가입 실패
      onFailure: () => {
        return fromJS({
          userData: null
        });
      },
      onPending: state => {
        return state.setIn(['register', 'loading'], true);
      }
    }),
    // 서비스 가입 데이터 초기화
    [SET_INITIAL]: () => {
      return initialState;
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/register.js